'use client';

import React from 'react';
import { DollarSign, TrendingDown, Clock, CheckCircle, AlertCircle, BarChart2 } from 'lucide-react';
import { MOCK_EXPENSES, EXPENSE_CATEGORIES, formatUGX } from './expensesData';
import { StatCard } from '@/components/ui/Cards';


export default function ExpenseSummaryCards() {
  const total = MOCK_EXPENSES.reduce((s, e) => s + e.amount, 0);
  const paid = MOCK_EXPENSES.filter(e => e.status === 'paid').reduce((s, e) => s + e.amount, 0);
  const pending = MOCK_EXPENSES.filter(e => e.status === 'pending' || e.status === 'approved').reduce((s, e) => s + e.amount, 0);
  const pendingCount = MOCK_EXPENSES.filter(e => e.status === 'pending').length;

  const byCat: Record<string, number> = {};
  MOCK_EXPENSES.forEach(e => { byCat[e.category] = (byCat[e.category] ?? 0) + e.amount; });
  const topCat = Object.entries(byCat).sort((a, b) => b[1] - a[1])[0];
  const topCatLabel = EXPENSE_CATEGORIES.find(c => c.value === topCat?.[0])?.label ?? topCat?.[0];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 mb-5">
      <StatCard label="Total Expenses" value={formatUGX(total)} sub="All categories" icon={DollarSign} iconBg="#fef2f2" iconColor="#dc2626" />
      <StatCard label="Paid / Settled" value={formatUGX(paid)} sub="Confirmed payments" icon={CheckCircle} iconBg="#f0fdf4" iconColor="#15803d" />
      <StatCard label="Pending Approval" value={String(pendingCount)} sub={formatUGX(pending) + ' awaiting'} icon={Clock} iconBg="#fffbeb" iconColor="#d97706" alert={pendingCount > 0} alertVariant="warning" />
      <StatCard label="Top Category" value={topCatLabel ?? '—'} sub={formatUGX(topCat?.[1] ?? 0)} icon={BarChart2} iconBg="#eff6ff" iconColor="#2563eb" />
      <StatCard label="Feed Costs" value={formatUGX(byCat['feed'] ?? 0)} sub="This period" icon={TrendingDown} iconBg="#fffbeb" iconColor="#d97706" />
      <StatCard label="Medicine Costs" value={formatUGX(byCat['medicine'] ?? 0)} sub="Vaccines & meds" icon={AlertCircle} iconBg="#faf5ff" iconColor="#7c3aed" />
    </div>
  );
}
